import { render, staticRenderFns } from "./TableOT.vue?vue&type=template&id=a36f8c52&"
import script from "./TableOT.vue?vue&type=script&lang=js&"
export * from "./TableOT.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports